<template>
    <component
      v-if="paymentProviderType"
      ref="payComponent"
      :is="paymentProviderComponent"
      :location="location"
      :payment-provider-public-options="paymentProviderPublicOptions"
      v-on="$listeners"/>
</template>

<script>
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      paymentProviderType: null,
      paymentProviderComponent: 'PayNull',
      paymentProviderPublicOptions: {},
    };
  },

  methods: {
    /* ===============
     * public methods
     */

    takeSalePayment(sale, allowDepositFlag) {
      if (this.paymentProviderType == null) {
        return;
      }

      this.$refs.payComponent.takeSalePayment(sale, allowDepositFlag);
    },

    takeBookingPayment(booking) {
      if (this.paymentProviderType == null) {
        return;
      }

      this.$refs.payComponent.takeBookingPayment(booking);
    },

    takeVoucherPayment(voucher) {
      if (this.paymentProviderType == null) {
        return;
      }

      this.$refs.payComponent.takeVoucherPayment(voucher);
    },

    takeVirtualGamePayment(virtualGame, sale, from) {
      if (this.paymentProviderType == null) {
        return;
      }

      this.$refs.payComponent.takeVirtualGamePayment(virtualGame, sale, from);
    },

    /*
     * END public methods
     * =============== */

    loadLocationPaymentProvider() {
      axios.get(this.route('api.locations.payment-provider.public', this.location))
        .then((response) => {
          if (response.status == 200) {
            this.paymentProviderPublicOptions = response.data.publicOptions;
            this.paymentProviderComponent = response.data.component;
            this.paymentProviderType = response.data.type;
          } else {
            flash('Error loading Location PaymentProvider', 'error');
            console.log('loadLocationPaymentProvider', response.data);
            console.log('loadLocationPaymentProvider', response.status);
            console.log('loadLocationPaymentProvider', response.statusText);
          }
        })
        .catch((error) => {
          flash('Error loading Location PaymentProvider', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('loadLocationPaymentProvider:422', error.response.data);
              // TODO: if The email has already been taken. ???
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('loadLocationPaymentProvider:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('loadLocationPaymentProvider:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('loadLocationPaymentProvider:401', error.response.data);
              window.location.reload();
            } else {
              console.log('loadLocationPaymentProvider: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('loadLocationPaymentProvider: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('loadLocationPaymentProvider: Error', error.message);
          }
        });
    },
  },

  mounted() {
    this.loadLocationPaymentProvider();
  },
}
</script>
